import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { ArticleModel } from "@/core/models/article.model";

interface ArticleGetParams {
    search?: string;
    catId?: string;
    isPub?: boolean;
    orderBy?: string;
}

@injectable()
export class ArticleRepo extends TableRepo<ArticleModel> {
    constructor() {
        super("/api/Article");
    }

    async getData(
        index: number,
        params: ArticleGetParams,
        pageSize = 10
    ): Promise<ApiPage<ArticleModel> | null> {
        return await super.getData(index, params, pageSize);
    }
}
